import { iconMap } from "./iconMap";
import styles from "./Icon.module.css";
import type { IconProps } from "./types";

export function Icon({
  className,
  name,
  size = "m",
  styleType = "outline",
  title,
}: IconProps) {
  const SvgIcon = iconMap[name]?.[styleType] ?? iconMap[name]?.outline;

  if (!SvgIcon) {
    return null;
  }

  return (
    <span className={[styles.icon, styles[size], className ?? ""].join(" ").trim()}>
      <SvgIcon aria-hidden={title ? undefined : true} focusable="false" role={title ? "img" : "presentation"} />
      {title ? <span className={styles.srOnly}>{title}</span> : null}
    </span>
  );
}
